/**
 * Constant values to be used in the modules related to rendering community interactive and dinamic site plans.
 */

import SitePlanLayer from "../enums/sitePlanLayer";

/**
 * There are zoom levels that triggers different functionalities in the community site plans. Place them in this
 * structure so we have them in a single source of truth.
 */
export const zoomLevelTriggers = {
    zoomLevelEnterInteractiveStateTrigger: 17,
    drawInteractiveSitePlanMarkers: 18,
    zoomLevelSitePlansFetchTrigger: 11,
    zoomLevelDrawSitePlansTrigger: 14,
}

/**
 * This look up structure is meant for community interactive maps. They represent which layers to show based
 * on the map zoom level. The key of the structure is an integer representing map zoom levels, the value are
 * the layers to show on each of those levels.
 * Progressive disclosure, where the approach is to dynamically enrich or simplify map details as users zoom
 * in or out, is supported by the layers and zoom levels of this look up.
 */
export const zoomLevelLayersLookup = new Map([
    [ 17, [ SitePlanLayer.StreetNames ]],
    [ 16, [ SitePlanLayer.Walkway ]],
    [ 15, [ SitePlanLayer.Water, SitePlanLayer.Golf ]],
    [ 14, [ SitePlanLayer.Grass, SitePlanLayer.Ground, SitePlanLayer.Street ]],
    [ 0, [ SitePlanLayer.Lots, SitePlanLayer.LotPolygons ]],
]);